import React from 'react';
interface BonusCardProps {
  title: string;
  description: string[];
  imageSrc: string;
  value?: string;
}
export function BonusCard({
  title,
  description,
  imageSrc
}: BonusCardProps) {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 flex flex-col cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToPricing} data-id="element-1">
      <div className="relative" data-id="element-2">
        <img src={imageSrc} alt={title} className="w-full h-auto aspect-square object-cover" data-id="element-3" />
        <div className="absolute top-4 right-4 bg-[#fbbf24] text-black font-bold px-3 py-1 rounded-full shadow-sm text-sm transform rotate-3" data-id="element-4">
          🎁 GRATIS HOY
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-5">
        <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-6">{title}</h3>
        <ul className="space-y-2 mb-4 flex-1" data-id="element-7">
          {description.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-8">
              <span className="text-[#10b981] font-bold" data-id="element-9">✓</span>
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}